import { AbbreviatedText } from 'ui/AbbreviatedText';
import { invoicesHelpers } from 'utils/helpers/invoices';
import type { TComponent } from 'utils/types/component';

import type { IPayoutInvoice } from 'models/Invoice/Payout';

import styles from './ExternalIdentityCell.module.scss';

interface IExternalIdentityCellProps {
    record: IPayoutInvoice;
}

export const ExternalIdentityCell: TComponent<IExternalIdentityCellProps> = (
    props,
) => {
    const { record } = props;

    const identity = record.externalIdentity;

    return (
        <AbbreviatedText
            text={identity}
            formatFunction={invoicesHelpers.formatIdentity}
            className={styles.text}
        />
    );
};
